// extracted by mini-css-extract-plugin
export default {"img-button-wrapper":"autopromoUrCWLp","img-button-wrapper--centered":"autopromoYjZpqV","autopromo-btn-img":"autopromoc6zS2S"};